import { completarLabelsMatrizImpresion } from '@/shared/utils/label_matriz_impresion.js';
import { completarUnidadTrabajo } from '@/shared/utils/unidad_trabajo.js';

export function agruparProcesosPorLinea(procesos) {
  if (!procesos || procesos.length === 0) return [];

  const grupos = [];
  let grupoActual = null;

  procesos.forEach((p) => {
    const esFueraDeLinea = p.esFueraDeLinea === true;
    const codigoRama = p.codigoRama ?? 0;

    if (p.tieneMaquina && p.codigoRecurso) {
      const puedeContinuarGrupo =
        grupoActual &&
        grupoActual.tieneMaquina &&
        grupoActual.codigoRecurso === p.codigoRecurso &&
        grupoActual.codigoRama === codigoRama &&
        !esFueraDeLinea;

      if (!puedeContinuarGrupo) {
        grupoActual = {
          esGrupo: false,
          tieneMaquina: true,
          esFueraDeLinea,
          codigoRecurso: p.codigoRecurso,
          codigoRama,
          esRamaPrincipal: p.esRamaPrincipal !== false,
          recursoDescripcion: p.recursoDescripcion || 'LÍNEA DE PRODUCCIÓN',
          titulo: '',
          procesos: [],
          esImpresion: false,
          metrosLinealesNetos: p.metrosLinealesNetos || 0,
          metrosLinealesBuenos: p.metrosLinealesBuenos || 0,
          metrosTotales: p.metrosTotales || 0,
          velocidad: p.velocidad,
          velocidadLinea: p.velocidadLinea || p.velocidad || 0,
          unidadTrabajo: completarUnidadTrabajo(p.unidadTrabajo),
          horasTotalesLinea: p.horasTotalesLinea || 0,
          mermaFija: p.mermaFija || 0,
          unidadMermaFija: p.unidadMermaFija ?? null,
          mermaPorcentual: p.mermaPorcentual || 0,
          mermaPorcentualAbsoluta: p.mermaPorcentualAbsoluta || 0,
          mermaFutura: p.mermaFutura || 0,
          mermaColor: p.mermaColor || 0,
          mermaPolimero: p.mermaPolimero || 0,
          // COTI-502: Determinar label para polimero
          labelsMatrizImpresion: completarLabelsMatrizImpresion(p.labelsMatrizImpresion),
          mermaTotal: p.mermaTotal || 0,
          horasProduccion: p.horasProduccion || 0,
          horasSetupTotal: p.horasSetupTotal || 0,
          horasSetupDetalle: {
            ajuste: p.horasSetupDetalle?.ajuste || 0,
            color: p.horasSetupDetalle?.color || 0,
            polimero: p.horasSetupDetalle?.polimero || 0,
            recarga: p.horasSetupDetalle?.recarga || 0,
          },
          divideBocas: p.divideBocas,
          factorCortes: p.factorCortes,
          materiales: Array.isArray(p.materiales) ? [...p.materiales] : [],
        };
        grupos.push(grupoActual);
      } else {
        grupoActual.esGrupo = true;

        grupoActual.metrosLinealesBuenos = p.metrosLinealesBuenos || 0;
        grupoActual.mermaFutura = p.mermaFutura || 0;

        grupoActual.mermaPorcentualAbsoluta += p.mermaPorcentualAbsoluta || 0;
        grupoActual.mermaColor += p.mermaColor || 0;
        grupoActual.mermaPolimero += p.mermaPolimero || 0;
        grupoActual.mermaTotal += p.mermaTotal || 0;
        grupoActual.horasSetupTotal += p.horasSetupTotal || 0;

        if (p.horasSetupDetalle) {
          grupoActual.horasSetupDetalle.ajuste += p.horasSetupDetalle.ajuste || 0;
          grupoActual.horasSetupDetalle.color += p.horasSetupDetalle.color || 0;
          grupoActual.horasSetupDetalle.polimero += p.horasSetupDetalle.polimero || 0;
          grupoActual.horasSetupDetalle.recarga += p.horasSetupDetalle.recarga || 0;
        }

        grupoActual.metrosTotales = Math.max(grupoActual.metrosTotales, p.metrosTotales || 0);
        grupoActual.horasProduccion = Math.max(grupoActual.horasProduccion, p.horasProduccion || 0);

        if (p.divideBocas) {
          grupoActual.divideBocas = true;
          grupoActual.factorCortes = p.factorCortes;
        }
        if (Array.isArray(p.materiales)) {
          grupoActual.materiales.push(...p.materiales);
        }
      }

      grupoActual.procesos.push(p);
      if (p.esImpresion) grupoActual.esImpresion = true;
    } else {
      // Un paso sin máquina corta cualquier cadena en curso: si el mismo
      // recurso vuelve a aparecer más adelante, no debe fusionarse con esto.
      grupoActual = null;
      grupos.push({
        esGrupo: false,
        tieneMaquina: false,
        esFueraDeLinea,
        codigoRama,
        titulo: p.descripcion,
        esImpresion: p.esImpresion,
        metrosTotales: p.metrosTotales,
        procesoOriginal: p,
        ...p,
        labelsMatrizImpresion: completarLabelsMatrizImpresion(p.labelsMatrizImpresion),
        unidadTrabajo: completarUnidadTrabajo(p.unidadTrabajo),
      });
    }
  });

  grupos.forEach((g) => {
    if (g.tieneMaquina && g.esGrupo) {
      g.titulo = g.procesos.map((p) => p.descripcion).join(' + ');
    } else if (g.tieneMaquina && !g.esGrupo) {
      g.titulo = g.procesos[0].descripcion;
    }
  });

  return grupos;
}
